import { VenueOperatorType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueOperatorTableRow } from './components';
import { venueOperatorRows } from './data';

type VenueOperatorTablePropsType = {
  venueOperator: VenueOperatorType;
};

export const VenueOperatorTable: React.FC<VenueOperatorTablePropsType> = ({
  venueOperator,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueOperatorRows.map((row) => (
          <VenueOperatorTableRow
            key={row.label}
            venueOperator={venueOperator}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
